<div class="main-container">
  <app-header [profilePhotoUrl]="profilePhotoUrl" (logoutClicked)="logout()" ></app-header>
  <mat-sidenav-container #sidenavContainer [className]="getClassList()" >
    @if (this.showSideNav) {
    <mat-sidenav #sidenav mode="side" class="sidenav">
      <app-sidenav-list (toggle)="onToggleSidenav($event)"></app-sidenav-list>
    </mat-sidenav>
    }
    <mat-sidenav-content>
      <div class="content-container">
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-footer></app-footer>
</div>
